import { reactive, computed } from '@vue/composition-api'
import { PRODUCT_STATUS } from '@/util/constants'
import { formatDateKanji, dataErrorMessage } from '@/util/common'
import * as _ from 'lodash'

export const ContractAssignLicense = (props, context) => {
  const store = context.root.$store
  const { users } = store.state


  const promiseList = [
    store.dispatch('contract/getContractData'),
    store.dispatch('contractPack/getPackageData'),
    store.dispatch('users/getUsersData')
  ]

  Promise
    .all(promiseList)
    .then(() => {
      state.initialize = true
    })
  

  const data = reactive({
    packages: computed(() => store.getters['contractPack/signedProductsInSignedPackages']),
    users: computed(() => store.getters['users/sortedLoginIdAndAuth'])
  })

  const action = reactive({
    showProduct: (packageIndex, productIndex) => {
      const product = _.get(data.packages, [packageIndex, 'product_lists', productIndex], {})
      store
        .dispatch('contractPack/setSelectProduct', product)
        .then(() => {
          state.visibleLicenseForPackage = true
        })
    },
    productClose: () => {
      state.visibleLicenseForPackage = false
    },
    productSubmit: (lists) => {
      if (lists.length > 0) {
        store.dispatch('common/showLoading')
        store
          .dispatch('users/bulkUpdateUser', lists)
          .then(async (data) => {
            Promise
              .all([store.dispatch('users/getUsersData'), store.dispatch('contractPack/getPackageData')])
              .then(() => {
                if (data.status === 0) store.dispatch('common/showToast', { text: 'ライセンスの付与状態を更新しました' })
              })
          })
          .finally(() => {
            store.dispatch('common/hideLoading')
            action.productClose()
          })
      } else {
        store.dispatch('common/showToast', { text: 'ライセンスの付与状態を更新しました' })
        action.productClose()
      }
    },
    createSubmit: (user) => {
      store.dispatch('common/showLoading')
      store
        .dispatch('users/addUser', user)
        .then(async (data) => {
          Promise
            .all([store.dispatch('users/getUsersData'), store.dispatch('contractPack/getPackageData')])
            .then(() => {
              if (data.status === 0) {
                store.dispatch('common/showToast', { text: 'アカウントを追加しました。' })
                state.visibleCreate = false
              } else {
                dataErrorMessage(data)
              }
            })
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    }
  })

  const state = reactive({
    initialize: false,
    visibleLicenseForPackage: false,
    visibleDetail: false,
    visibleCreate: false,
    visibleEdit: false,
    visibleAdminTransfer: false
  })

  return {
    state,
    data,
    action,
    formatDateKanji,
    PRODUCT_STATUS
  }
}
